import React from 'react';
import cx from 'classnames';
import styles from './NavItem.module.scss';
import type { NavItemProps } from './NavItem.types';

const NavItem = (props: NavItemProps) => {
  const {
    className,
    children,
    ...restProps
  } = props;
  return (
    <li
      {...restProps} 
      className={cx(styles.navItem, className)}
    >
      {children}
    </li>
  );
};
export default NavItem;
